var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowRightS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20 20H0V0h20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.34 10.5l.07-.09a1 1 0 000-.82l-.06-.09a1.08 1.08 0 00-.18-.23l-6-5a1 1 0 10-1.31 1.5L13.74 9H3.5a1 1 0 000 2h10.24l-3.88 3.23a1 1 0 00-.13 1.41 1 1 0 00.77.36 1 1 0 00.64-.23l6-5a.81.81 0 00.2-.27z"
  })));
}

export default SvgIconArrowRightS;